document.addEventListener("DOMContentLoaded", function () {
  const stickyAtc = document.getElementById("StickyATC");
  const atcButton = document.querySelector('.product-form__submit[name="add"]');
  const stickyButton = document.querySelector(".sticky-atc__button");

  
  if (!stickyAtc || !atcButton || !stickyButton) return;

  // --- show/hide sticky ATC ---
  const toggleStickyVisibility = (isIntersecting, rect) => {
    const isAboveViewport = rect
      ? rect.top < 0
      : window.scrollY > atcButton.offsetTop;

    if (!isIntersecting && isAboveViewport) {
      stickyAtc.classList.add("show");
    } else {
      stickyAtc.classList.remove("show");
    }
  };

  // Initial Check for Page Refresh
  setTimeout(() => {
    const initialRect = atcButton.getBoundingClientRect();
    const isInitialVisible =
      initialRect.top >= 0 && initialRect.bottom <= window.innerHeight;
    toggleStickyVisibility(isInitialVisible, initialRect);
  }, 100);

  // Continuous Observer for Scrolling
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        toggleStickyVisibility(entry.isIntersecting, entry.boundingClientRect);
      });
    },
    {
      threshold: 0,
      rootMargin: "0px 0px -120px 0px",
    },
  );
  observer.observe(atcButton);

  // ---  Scroll Color Option Click ---
  try {
    const stickyColorOption = document.getElementById("StickyColorOption");
    const pdpColorSwatch = document.getElementById("PDPColorSwatch");

    if (stickyColorOption && pdpColorSwatch) {
      stickyColorOption.addEventListener("click", function () {
        pdpColorSwatch.scrollIntoView({
          behavior: "smooth",
          block: "center" 
        });
      });
    }
  } catch (error) {
    console.warn("Sticky ATC color scroll failed to initialize:", error);
  }

  // --- Sticky Add to cart functionality -----
  let stickyErrorTimeoutId = null;
  stickyButton.addEventListener("click", async function (e) {
    e.preventDefault();

    if (stickyButton.classList.contains("loading") || stickyButton.hasAttribute("disabled")) {
      return;
    }
    
    const variantId = stickyButton.dataset.variantId;
    const loaderEl = stickyButton.querySelector(".product-card__spinner");
    const textEl = stickyButton.querySelector("span");
    const stickyContainer = stickyButton.closest('#StickyATC');
    const errorWrapper = stickyContainer?.querySelector(".product-form__error-message-wrapper");
    const errorMessageEl = stickyContainer?.querySelector(".product-form__error-message");

    if (stickyErrorTimeoutId) {
      clearTimeout(stickyErrorTimeoutId);
    }

    if (errorWrapper) errorWrapper.setAttribute("hidden", "");
    if (errorMessageEl) errorMessageEl.textContent = "";

    // Show loader
    stickyButton.classList.add("loading");
    stickyButton.setAttribute("aria-disabled", "true");
    if (loaderEl) loaderEl.classList.remove("hidden");

    // Capture and set "Adding" state
    let originalText = "";
    if (textEl) {
      originalText = textEl.textContent;
      textEl.textContent = window.variantStrings?.adding || "ADDING";
    }

    try {
      const config = { ...fetchConfig('javascript') };
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      formData.append('form_type', 'product');
      formData.append('sections', "cart-drawer,cart-icon-bubble");
      config.body = formData;

      const response = await fetch(`${routes.cart_add_url}`, config);
      const data = await response.json();

      if (!response.ok || data.status || data.description) {
        const errorMessage = data.description || data.message || "Something went wrong!";
        throw new Error(errorMessage);
      }

      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        if (cartDrawer.classList.contains("is-empty")) {
          cartDrawer.classList.remove("is-empty");
        }
        cartDrawer.renderContents(data);
        cartDrawer.open();
      }

    } catch (error) {
      console.error("Error adding to cart:", error);
      
      if (errorMessageEl && errorWrapper) {
        errorMessageEl.textContent = error.message;
        errorWrapper.removeAttribute("hidden");
        stickyErrorTimeoutId = setTimeout(() => {
          errorWrapper.setAttribute("hidden", "");
          errorMessageEl.textContent = "";
        }, 7000); 
      }
    } finally {
      if (loaderEl) {
        loaderEl.classList.add("hidden");
      }
      // Restore original button text
      if (textEl && originalText) {
        textEl.textContent = originalText;
      }

      stickyButton.classList.remove("loading");
      stickyButton.removeAttribute("aria-disabled");
    }
  });
});